import { render, staticRenderFns } from "./1-onboarding.vue?vue&type=template&id=c94268a8&"
import script from "./1-onboarding.vue?vue&type=script&lang=js&"
export * from "./1-onboarding.vue?vue&type=script&lang=js&"
import style0 from "./1-onboarding.vue?vue&type=style&index=0&id=c94268a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports